import { OFFER_EXPIRED_URL } from '../config/serviceUrl';
import { domainPrefix } from '../config/domainPrefix';

/**
 * Redirect to the corresponding vendor's expired page
 * @param {String} vendor
 */
export const redirectCampaignExpired = (vendor: string): void => {
    if (process.env.APP_ENV !== 'dev') {
        window.location.replace(`https://${domainPrefix}${vendor}${OFFER_EXPIRED_URL[vendor]}?expired_promo`);
    } else {
        console.log('campaign is not active, normally we would redirect to the offer expired page now.');
    }
};

/**
 * Get all query parameters to be updated
 * without removing any other parameter
 *
 * @private
 * @param {string} query Query to parse
 * @return {array} with all query parameters
 */
export const getQueryParameters = (query: string): any => {
    const queryParams = {};
    if (query) {
        query
            .replace(/^\?/, '')
            .split('&')
            .forEach((item) => {
                const [k, v] = item.split('=');
                const newParam = v && decodeURIComponent(v);
                (queryParams[k] = queryParams[k] || []).push(newParam);
            });
    }
    return queryParams;
};

/**
 * Transform an array of query parameters into a string of parameters
 *
 * @private
 * @param {array} params Array of parameters
 * @return {string} Resulting query
 */
export const buildQueryString = (params: Array<any>): string => {
    const queryString: string[] = [];
    for (const paramName in params) {
        const paramValues = Array.isArray(params[paramName]) ? params[paramName] : [params[paramName]];

        for (const value of paramValues) {
            let keyValuePair = [paramName];

            if (value) {
                keyValuePair.push(value);
            }

            keyValuePair = keyValuePair.map((part) => encodeURIComponent(part));

            queryString.push(keyValuePair.join('='));
        }
    }
    return queryString.join('&');
};

/**
 * Update a parameter in the provided URL
 *
 * @param {string} url Initial URL
 * @param {string} key Parameter name
 * @param {string} value Parameter value
 * @return {string} Updated Url
 */
export const updateUrlParameter = (url: string, key: string, value: string): string => {
    const urlParts = url.split('?');
    const params = getQueryParameters(urlParts[1] || '');
    params[key] = value;
    urlParts[1] = buildQueryString(params);
    return urlParts.join('?');
};

/**
 * Get Search engine from which user entered the page
 *
 * @returns {string|null}
 */
export const getSEOReferrerEngine = (): string | null => {
    const seoEngines = {
        Google: ['google.', 'googlesyndication.com'],
        'Microsoft Bing': ['bing.com'],
        'Yahoo!': ['yahoo.com', 'yahoo.co.jp'],
        Ask: ['ask.jp', 'ask.co'],
        'Yandex.ru': ['yandex'],
        'MyWay.com': ['myway.com'],
        AOL: ['.aol.', 'suche.aolsvc.de'],
        Other: [
            '.baidu.com',
            'daum.net',
            'naver.com',
            'seznam',
            'tiscali.it',
            'www.tiscali.co.uk',
            'search.earthlink.net',
            'optimum.net',
        ],
    };

    const referrerDomain = document.referrer || null;

    //Check if referrer exists (only then we can check if it's SEO traffic)
    if (referrerDomain) {
        for (const engine in seoEngines) {
            const domainFound = seoEngines[engine].find((domain: string) => referrerDomain.indexOf(domain) > -1);
            if (domainFound) {
                return engine;
            }
        }
    }

    return null;
};

export const getBnclCampaignId = (): string => {
    const maybeBnclsIdAsArray = getQueryParameters(location.search.substr(1))?.bnclCampaign;
    return (maybeBnclsIdAsArray ?? [])[0];
};

export const getBnclCampaignIsPreview = () => {
    const maybeIsBnclPreviewAsArray = getQueryParameters(location.search.substr(1)).bnclPreview;
    const bnclIsPreviewValue = (maybeIsBnclPreviewAsArray ?? [])[0];

    return bnclIsPreviewValue === 'true';
};
